// extracted by mini-css-extract-plugin
export default {"r-title":"_timeout_r-title_xQwhH"};